import { useNavigate } from 'react-router-dom';
import { Routes } from '../common/router/constants';
import { Card, Typography } from '@otp/ui';
import { Config } from '@otp/icons';
import { useTranslation } from 'react-i18next';

export const UserEditCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () => {
    navigate(Routes.editProfile.path);
  };

  return (
    <Card
      className="hover:bg-[var(--mui-palette-primary-200)] cursor-pointer"
      onClick={onClick}
    >
      <div className="grid grid-cols-12 items-center">
        <Typography variant="subtitle2" className="col-span-11">
          {t('user-profile.actions.edit')}
        </Typography>
        <Config />
      </div>
    </Card>
  );
};
